import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'

import { errorLogger } from 'api/middlewareApi'

import { currenciesApi } from 'services/currency'
import { dictionariesApi } from 'services/dictionaries'
import { operationsApi } from 'services/operations'
import { organizationApi } from 'services/organizations'
import { templatesApi } from 'services/templates'
import { userApi } from 'services/user'

import { actionListener } from '../providers/listeners'
import { walletsApi } from '../services/wallets'
import { appReducer } from './app-reducer'
import { dashboardReducer } from './dashboard-reducer'

const rootReducer = combineReducers({
  [walletsApi.reducerPath]: walletsApi.reducer,
  [operationsApi.reducerPath]: operationsApi.reducer,
  [dictionariesApi.reducerPath]: dictionariesApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [currenciesApi.reducerPath]: currenciesApi.reducer,
  [templatesApi.reducerPath]: templatesApi.reducer,
  [organizationApi.reducerPath]: organizationApi.reducer,
  app: appReducer,
  dashboard: dashboardReducer,
})

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    })
      .prepend(actionListener.middleware)
      .concat(
        walletsApi.middleware,
        operationsApi.middleware,
        dictionariesApi.middleware,
        templatesApi.middleware,
        userApi.middleware,
        currenciesApi.middleware,
        organizationApi.middleware,
        errorLogger
      ),
})

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof rootReducer>
export type RootReducerType = typeof rootReducer
export type AppRootStateType = ReturnType<RootReducerType>
export type AppDispatch = typeof store.dispatch
